import {environment} from '../../../../environments/environment';

export const activities = {
    actionButtonsInMultiMatrix: {
        default: ['previousActivityInMulti', 'nextActivityInMulti']
    },
    activitiesDisplayedColumns: ['title', 'educationalLevel', 'chapters', 'action'],
    allowErrorReporting: false,
    accessMatrix: {
        activitiesListing: {
            view: ['trainer', 'manager', 'administrator'],
        },
        lessonsListing: {
            view: ['learner', 'trainer', 'manager', 'administrator'],
        }
    },
    addRootFilter: true,
    allowedActivityTypes: [],
    allowedAssignmentSpecificView: true,
    allowedRolesForModelsAssignation: ['manager', 'director', 'trainer'],
    // required params name for partner through iframe url
    APIPEMTask: true,
    applyFilterLessonAssignedOnly: true,
    autoCorrection: true,
    buttons: {
        player: {
            auto: [
                {
                    title: 'generic.next',
                    type: 'next',
                    preActionMatrix: ['save'],
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: true
                            },
                            disable: {
                                case: 'disableWithDelay',
                                value: 3000
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        IMG: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                    },
                },
                {
                    title: 'generic.next',
                    type: 'next',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        IMG: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                    },
                },
                {
                    title: 'generic.validate',
                    type: 'validate',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        CRT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        RB: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
            ],
            preview: [
                {
                    title: 'generic.next',
                    type: 'next',
                    preActionMatrix: ['save'],
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: true
                            },
                            disable: {
                                case: 'disableWithDelay',
                                value: 3000
                            }
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                        IMG: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                    },
                },
                {
                    title: 'generic.next',
                    type: 'next',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        IMG: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                    },
                },
                {
                    title: 'generic.validate',
                    type: 'validate',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        CRT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        RB: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
            ],
            training: [
                {
                    title: 'generic.next',
                    type: 'next',
                    preActionMatrix: ['save'],
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: true
                            },
                            disable: {
                                case: 'disableWithDelay',
                                value: 3000
                            },
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                        IMG: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                    },
                },
                {
                    title: 'generic.next',
                    type: 'next',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        IMG: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                    },
                },
                {
                    title: 'generic.validate',
                    type: 'validate',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        CRT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        RB: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
            ],
            homework: [
                {
                    title: 'generic.next',
                    type: 'next',
                    preActionMatrix: ['save'],
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: true
                            },
                            disable: {
                                case: 'disableWithDelay',
                                value: 3000
                            },
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                        IMG: {
                            display: {
                                case: 'force',
                                value: false,
                            },
                        },
                    },
                },
                {
                    title: 'generic.next',
                    type: 'next',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        MULTI: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        Tool: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        EXT: {
                            display: {
                                case: 'force',
                                value: false
                            }
                        },
                        awareness: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        recording: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                        IMG: {
                            display: {
                                case: 'force',
                                value: true,
                            },
                        },
                    },
                },
                {
                    title: 'generic.validate',
                    type: 'validate',
                    classCss: ['btn-option', 'btn-next'],
                    display: false,
                    options: {
                        CRT: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        RB: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        VF: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        QCMU: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missing: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                        missingaudio: {
                            display: {
                                case: 'force',
                                value: true
                            }
                        },
                    },
                },
            ],
        },
    },
    cardFieldsForPreview: ['chapters', 'description'],
    cardLayout: 'card-split-media-info',
    canSelectActivities: true, // can select activities when assign lesson
    checkAnswersAfterLoadUserSave: false, // check answers after automatically after user save is loaded
    displayFilters: false,
    displayLearnerInfo: false,
    displayTipsInListOfActivities: true,
    dynamicContent: false,
    exitLessonAfterConfirm: true,
    extraActionAfterUserSave: true,
    filtersEditorActivitiesList: ['title', 'educationnalLevel', 'chapters'],
    forcedPreviewOption: {preview: true, isActivitiesListMustBeDisplayed: true},
    forceUrl: true,
    getAssignatedUserUid: true,
    hideAddButtonLessonList: true,
    hideUserActionButtons: true,
    hiddenActivityPreview: false,
    iframeParams: [],
    initialiseIframeUrl: true,
    isActivitiesListMustBeDisplayed: true,
    isLaunchLessonAskModalActive: {default: true, learner: false},
    isAccessPythonRules: true,
    isDisplayingRewards: true,
    isLessonAssignedUsePythonRule: true,
    isLessonPreviewAccessible: {default: true, learner: false},
    isListFormatStepper: true, // stepper is in list format (mat-select)
    isOnboardingEnabled: false,
    isOnlyModelLesson: true, // should be called by example : enableSelectionByTab for lesson list component
    isPercentileDisplayAllowed: false,
    isPlayLessonActionIsLimitedToCollectiveAssignment: true,
    isStepperAllowedAllStep: true,
    latexKeyboard: false,
    lessonDialogRequiredFields: {
        default: ['title', 'educationalLevel'],
    },
    lessonStep: null,
    listenActivatedRouteToManageContest: true,
    listenActivatedRouteToManageContestbase: true,
    loadPaginatedLessonsUseCitizenCodeLogic: true,
    loadSubActivitiesOfAllSubLesson: false,
    menu: {
        models: true
    },
    noStepperOnExternal: true,
    openDialogInfoAfterDuplicateLesson: {
        manager: false,
        default: true
    },
    openReviewPopupPassExtraDataIdLessonAndActivity: true,
    progress: false,
    recommendationDisplayedColumns: ['checkbox', 'pseudo', 'lesson', 'level', 'confidence', 'buttons'],
    saveLessonContentOptions: {
        activityTypesCanBeDuplicate: [], // type d'activitiés que l'on peut dupliquer (certaines activitiés n'ont pas besoin d'être dupliqué)
        saveContent: true // si chaque activités ou souslesson du parcours doit être sauvegardé
    },
    saveProgressOnSummarySubLesson: true,
    searchFields: {
        default: {
            default: ['chapters', 'chapters-toogle'] // we use chapter as toogle button
        }
    },
    setAnswerWithUserSave: false, // à l'initialisation d'une activité, inscrit les réponses presente dans l'user-save
    setAssignmentBeforeInit: true,
    setConceptFilterInRegardOfSelectedRootFilter: true,
    shouldSetDefaultOptionsOnActivityList: true,
    showActivityRewardsOnStorylineCompleted: true,
    showAddLessonButtonCard: true,
    showBookmarkButton: false,
    showLessonTitle: false,
    stepper: {
        default: { // role
            default: { // assignment type
                align: 'space-evenly',
                position: 'top',
                showRecap: false,
                stepValidationNeedSave: false
            }
        },
        learner: { // role
            default: null, // assignment type
            training: { // assignment type
                align: 'space-evenly',
                position: 'top',
                showRecap: false,
                stepValidationNeedSave: false,
                isListFormatStepper: false
            },
            homework: { // assignment type
                align: 'space-evenly',
                position: 'top',
                showRecap: false,
                stepValidationNeedSave: false,
                isListFormatStepper: false
            }
        },
    },
    typeActivitiesToSkip: [], // (lesson player) skip activity if activity's type is included,
    useExitLessonUrl: true,
    useFeedBack: true,
    useSummaryPageInsteadOfRecap: true,
    useTestAnswer: false,
    openSurveyOnlyForNotGarUser: true,
};
